import { render, staticRenderFns } from "./FirstCallStatistics.vue?vue&type=template&id=b8ea3e08&"
import script from "./FirstCallStatistics.vue?vue&type=script&lang=js&"
export * from "./FirstCallStatistics.vue?vue&type=script&lang=js&"
import style0 from "./FirstCallStatistics.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports